export default "<re-captcha (resolved)=\"resolved($event)\" siteKey=\"6LdbJHYqAAAAAHFBt-vySM57HFWLRLNdGN8AyCld\"></re-captcha>\n";